import { QSAiCareerCounsellor } from "../assets/index.jsx";
import { getExternalAppUrl } from "../services";

// Static links shown in the header (not part of the Quick Services list)
export const HEADER_NAVIGATION_URL = {
  aiCareerCounsellor: {
    dev: "https://career.gyandiksha.in/",
    prod: "https://career.gyandiksha.in/",
    uat: "https://guidance-ai.usk.gujgov.edu.in/",
  },
};

export const headerNavigationConfig = (t) => [
  {
    key: "aiCareerCounsellor",
    title: t ? t("portal_selection.ai_career_counsellor", "AI Career Counsellor") : "AI Career Guide",
    config: {
      img: QSAiCareerCounsellor,
      icon: "fluent:bot-sparkle-24-filled",
    },
    url: getExternalAppUrl(HEADER_NAVIGATION_URL.aiCareerCounsellor),
    target: "_blank",
  },
];

const normalizeKey = (value = "") => String(value).toLowerCase().replace(/[^a-z0-9]/g, "");

// True when a Quick Services menu item is already shown as a static header link
export const isHeaderNavigationItem = (name = "") => {
  const normalized = normalizeKey(name);
  return Boolean(normalized) && headerNavigationConfig().some((item) =>
    normalized === normalizeKey(item.key) || normalized === normalizeKey(item.title)
  );
};

export default headerNavigationConfig;
